import { render, staticRenderFns } from "./LxBtn.vue?vue&type=template&id=0f42de51&scoped=true"
import script from "./LxBtn.vue?vue&type=script&lang=js"
export * from "./LxBtn.vue?vue&type=script&lang=js"
import style0 from "./LxBtn.vue?vue&type=style&index=0&id=0f42de51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42de51",
  null
  
)

export default component.exports